
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-calendar",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-calendar"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M2.5 3.5h13v12h-13z"}}),_c('path',{staticClass:"i-calendar__rule",attrs:{"d":"M4.02 7.5h9.88"}}),_c('path',{attrs:{"d":"M5.5 5V1.5m7 3.5V1.5"}})])
          )
        }
      }
    